import { Link } from 'react-router-dom'
import { useCollection } from '../hooks/useFirestore'
import { getShipTypeLabel } from '../lib/shipTypes'
import './ShipsPage.css'

const PLACEHOLDER_SHIP = 'data:image/svg+xml,' + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <rect fill="#1E1A22" width="100" height="100"/>
    <path d="M20 60 L50 45 L80 60 L75 70 L25 70 Z" fill="#6E2EBF"/>
    <rect x="48" y="30" width="4" height="20" fill="#6E2EBF"/>
    <path d="M52 30 L52 45 L70 40 Z" fill="#8B5CF6"/>
  </svg>
`)

export default function ShipsPage() {
  const { data: ships, loading, error } = useCollection('ships', { orderByField: 'sortOrder' })

  // Filter out hidden ships
  const visibleShips = ships.filter(s => s.hidden !== true)

  if (loading) {
    return (
      <div className="container">
        <div className="ships-loading">
          <div className="loading-spinner" />
          <p>Loading ships...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="container">
        <div className="ships-error">
          <h2>Error loading ships</h2>
          <p>{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <div className="ships-header">
        <h1>Ships</h1>
        <p className="text-secondary">Vessels of the campaign.</p>
      </div>

      {visibleShips.length === 0 ? (
        <div className="ships-empty">
          <p>No ships yet.</p>
          <p className="text-secondary">Ships will appear here as they're encountered.</p>
        </div>
      ) : (
        <div className="ships-grid">
          {visibleShips.map(ship => {
            const isDestroyed = ship.destroyed === true
            return (
              <Link
                key={ship.id}
                to={`/ships/${ship.id}`}
                className={`ship-card ${isDestroyed ? 'destroyed' : ''}`}
              >
                <div className="ship-image">
                  <img
                    src={ship.imageUrl || PLACEHOLDER_SHIP}
                    alt={ship.name}
                    onError={(e) => { e.target.src = PLACEHOLDER_SHIP }}
                  />
                  {isDestroyed && (
                    <span className="ship-destroyed-badge">Destroyed</span>
                  )}
                  <span className="ship-type-badge">
                    {getShipTypeLabel(ship.type)}
                  </span>
                </div>
                <div className="ship-info">
                  <h3>{ship.name}</h3>
                  {ship.crew?.length > 0 && (
                    <p className="ship-crew-count">{ship.crew.length} crew members</p>
                  )}
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
